import React from 'react'
import './facultymembers.css'
const FacultyMembers = () => {
  return (
  <>
<div className="parentForFacultyMembers">
 <div className="facultyMembersWrapper">
    <div className="facultyMembersContent">
    <div className="headingWrapFor">
    <h4>The faculty experts of NAME:</h4>
  </div>
<div className="stylesForNameFaculty">
    
<div className="styledWrapForContentFacultyMembers">
       <div className="membersContentOneWrapperFacultyMembers">
       <div className="styledMembersContentFacultyMembers">
             <div className="membersContentOneFacultyMembers">

             <div className="teachersNameContainerFacultyMembers">
             <h2 className='subjectHeader'>Chemistry</h2>
                  <h4 className='fontWeighSmall'>Mr. Mahesh Poudel</h4>
                  <h4 className='fontWeighSmall'>Mr. Rajesh Kumar Shah</h4>
                  <h2 className='subjectHeader'>Physics</h2>
                  <h4 className='fontWeighSmall'>Mr. Dipak Bhattarai</h4>
                  <h4 className='fontWeighSmall'>Mr. Ram Tiwari</h4>
                  <h2 className='subjectHeader'>Biology</h2>
                  <h4 className='fontWeighSmall'>Dr. Madhav Rijal</h4>
                  <h4 className='fontWeighSmall'>Dr. Kabir Pokhrel</h4>
                  <h4 className='fontWeighSmall'>Dr. Dorna Pokhrel</h4>
                  <h4 className='fontWeighSmall'>Mr. Kamal Nepal</h4>
                  <h4 className='fontWeighSmall'>Dr. Nirajan Neupane</h4>
                  <h2 className='subjectHeader'>Mat</h2>
                  <h4 className='fontWeighSmall'>Mr. Shankar Kandel</h4>

                  <div className="teachersNameContainerFacultyMembers">
             <h4 className='subjectHeaderwithBackground'>Institute of Engineering (IOE).
                  <br/>
                  Pulchowk Campus
                  </h4>
                  <h3 className='subjectHeader'>Physics</h3>
                  <h4 className='fontWeighSmall'>Prof. Dr. Bhadra Pokhrel</h4>
                  <h3 className='subjectHeader'>Chemistry</h3>
                  <h4 className='fontWeighSmall'>Prof. Dr. Ram Kumar Shrestha</h4>
                  <h3 className='subjectHeader'>Physics</h3>
                  <h4 className='fontWeighSmall'>Prof. Dr. Binod Kumar Bhattarai</h4>
                  <h3 className='subjectHeader'>Maths</h3>
                  <h4 className='fontWeighSmall'>Prof. Dr. Vinod Parajuli</h4>
                  <h3 className='subjectHeader'>Chemistry</h3>
                  <h4 className='fontWeighSmall'>Prof. Dr. Hemraj Panta</h4>
                  <h3 className='subjectHeader'>Physics</h3>
                  <h4 className='fontWeighSmall'>Dr. Ganesh Shrestha</h4>
                  </div>
             </div>
             </div>
       </div>
       </div>
       </div>
</div>
    </div>
  </div>

</div>

  </>
  )
}

export default FacultyMembers